function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeckleLogo = function SvgSpeckleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "56 39 240 249"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h3840v2160H0z",
    style: {
      fill: "none"
    },
    transform: "translate(-1707.24 -325.43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1294.87 614.156h204.453v204.719H1294.87z",
    style: {
      fill: "#047efb"
    },
    transform: "matrix(.99848 -.05521 0 1.00153 -1202.529 -461.582)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.94 618.105h206.242v64.29H643.94z",
    style: {
      fill: "#7bbcff"
    },
    transform: "matrix(.98981 -.05473 .52452 .47152 -904.947 -204.501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1736.88-457.431h93.132v152.477h-93.132z",
    style: {
      fill: "#313bcf"
    },
    transform: "matrix(.36208 .3255 0 1.34467 -572.24 101.453)"
  }));
};
export default SvgSpeckleLogo;